import React,{ useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getPermisUserRuta } from "../../services/user";
import NoPermission from "../../components/nopermission";

const HasPermission = ({ paths, element }) => {
  const [permisos, setPermisos] = useState([]);
  const [component, setComponent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ObtenerPermisos = async () => {
      try {
        const response = await getPermisUserRuta(paths);

        if (!response) {
          setComponent(<NoPermission />);
          return;
        }

        if (response.data?.user?.Rol === 1) {
          // Rol 1 = admin, acceso completo
          setPermisos(['ADMIN']);
          setComponent(element);
        } 
        else if (response.data?.data) {
          const lista = response.data.data.map((item) => item.CodigoItem);
          setPermisos(lista);

          if (lista.includes('RUN')) {
            setComponent(element);
          } else {
            setComponent(<NoPermission />);
          }
        } else {
          setComponent(<NoPermission />);
        }
      } catch (error) {
        setComponent(<NoPermission />);
      } finally {
        setLoading(false);
      }
    };

    ObtenerPermisos();
  }, [paths, element]);

  // Si el componente ya fue evaluado, lo clonamos con permisos
  return component && React.cloneElement(component, { permisos });
};

export default HasPermission;